module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTczMCA1ODguOGwtMTk0LjMtMTk0LjNhMzIgMzIgMCAwIDAtNDUuMyAwTDI5Ni4zIDU4OC44YTMyIDMyIDAgMCAwIDIyLjYgNTQuN2gzODguNmEzMiAzMiAwIDAgMCAyMi42LTU0Ljd6IiBmaWxsPSIjMCIgcC1pZD0iMzI4MiI+PC9wYXRoPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/Caret up-filled.svg
// module id = PHun
// module chunks = 74